import { useState, useEffect } from 'react';
import {
  getSoldesCaisseNoire, getTotalCaisseNoire, getCaisseNnoireRegles, getCategoriesCN,
  createRegle, updateRegle, deleteRegle, getJoueurs, addAmende,
  getTransactionsJoueur, getImpayees,
  payerAmendes, payerTout,
  annulerAmende, reactiverAmende, transfererAmende, deleteTransaction,
  getDefis, createDefi, updateDefi, deleteDefi, tirerDefi, getQuotaDefis,
  createCategorieCN, updateCategorieCN, deleteCategorieCN, hasRole, getCurrentUser
} from '../api';

const eur = v => (v || 0).toFixed(2).replace('.', ',') + ' €';

export default function CaisseNoirePage() {
  const [tab, setTab]           = useState('soldes');
  const [soldes, setSoldes]     = useState([]);
  const [total, setTotal]       = useState(null);
  const [regles, setRegles]     = useState([]);
  const [cats, setCats]         = useState([]);
  const [defis, setDefis]       = useState([]);
  const [joueurs, setJoueurs]   = useState([]);
  const [selPaye, setSelPaye]   = useState([]);
  const [selJoueur, setSelJoueur]       = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [panel, setPanel]       = useState(null);
  const [form, setForm]         = useState({});
  const [cibles, setCibles]     = useState([]);
  const [openCat, setOpenCat]   = useState(null);
  const [tirage, setTirage]     = useState(null);
  const [transfert, setTransfert] = useState(null);
  const [quotas, setQuotas]     = useState([]);
  const [editRegle, setEditRegle] = useState(null);
  const [editDefi, setEditDefi]   = useState(null);
  const [newDefi, setNewDefi]     = useState('');
  const [editCat, setEditCat]     = useState(null);
  const [showCats, setShowCats]   = useState(false);
  const [toast, setToast]       = useState(null);
  const isAdmin = hasRole('tresorier');
  const monJoueurId = getCurrentUser()?.joueur_id;

  useEffect(() => { load(); }, []);
  async function load() {
    const [s, t, r, c, j, d, q] = await Promise.all([
      getSoldesCaisseNoire(), getTotalCaisseNoire(), getCaisseNnoireRegles(),
      getCategoriesCN(), getJoueurs(), getDefis(),
      getQuotaDefis().catch(()=>[])
    ]);
    setSoldes(s); setTotal(t); setRegles(r); setCats(c);
    setJoueurs(j.filter(x => x.actif)); setDefis(d); setQuotas(q);
  }
  function showToast(msg, type='success') { setToast({msg,type}); setTimeout(()=>setToast(null),3000); }

  async function openJoueur(id) {
    setSelPaye([]);
    if (selJoueur === id) return setSelJoueur(null);
    setSelJoueur(id);
    setTransactions(await getTransactionsJoueur(id));
  }

  function openAmende(regle) {
    setForm({ regle_id: regle?.id || '', montant: regle?.montant ?? '', libelle: regle?.libelle || '',
              jour_match: false, date: new Date().toISOString().split('T')[0] });
    setCibles(regle?.collective ? joueurs.map(j => j.id) : []);
    setPanel('amende');
    setTab('soldes');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  async function submitAmende(e) {
    e.preventDefault();
    if (!cibles.length) return showToast('Sélectionne au moins un joueur', 'error');
    try {
      const r = await addAmende({ ...form, joueurs: cibles });
      showToast(`${r.nb} amende${r.nb>1?'s':''} · ${eur(r.total)}`);
      setPanel(null); setForm({}); setCibles([]); load();
      if (selJoueur) setTransactions(await getTransactionsJoueur(selJoueur));
    } catch(err) { showToast(err.message, 'error'); }
  }

  async function encaisser(jid) {
    if (!selPaye.length) return;
    try {
      const r = await payerAmendes(selPaye, true);
      showToast(`${r.nb} amende${r.nb>1?'s':''} encaissée${r.nb>1?'s':''} · ${eur(r.total)}`);
      setSelPaye([]); refresh(jid);
    } catch(err) { showToast(err.message, 'error'); }
  }

  async function togglePaye(t, jid) {
    try {
      await payerAmendes([t.id], !t.payee);
      showToast(t.payee ? 'Marquée impayée' : `${eur(t.montant)} encaissés`);
      refresh(jid);
    } catch(err) { showToast(err.message, 'error'); }
  }

  async function soldeTout(s) {
    if (!window.confirm(`Encaisser les ${s.nb_impayees} amendes de ${s.prenom} ?\n\nTotal : ${eur(s.solde)}`)) return;
    try {
      const r = await payerTout(s.id);
      showToast(`${eur(r.total)} encaissés`);
      setSelPaye([]); refresh(s.id);
    } catch(err) { showToast(err.message, 'error'); }
  }

  async function submitRegle(e) {
    e.preventDefault();
    try {
      if (editRegle) { await updateRegle(editRegle.id, form); showToast('Règle modifiée'); setEditRegle(null); }
      else { await createRegle(form); showToast('Règle ajoutée'); }
      setPanel(null); setForm({}); load();
    } catch(err) { showToast(err.message, 'error'); }
  }

  function openEditRegle(r) {
    if (panel === 'regle' && editRegle?.id === r.id) { setPanel(null); setEditRegle(null); setForm({}); return; }   // second clic : on referme
    setEditRegle(r);
    setForm({ libelle:r.libelle, montant:r.montant, categorie_id:r.categorie_id||'', collective:!!r.collective });
    setPanel('regle');
    setTimeout(() => document.getElementById(`regle-${r.id}`)?.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 60);
  }

  async function submitDefi(e) {
    e.preventDefault();
    try {
      if (editDefi) { await updateDefi(editDefi.id, { libelle: newDefi }); showToast('Défi modifié'); setEditDefi(null); }
      else { await createDefi({ libelle: newDefi }); showToast('Défi ajouté'); }
      setNewDefi(''); load();
    } catch(err) { showToast(err.message, 'error'); }
  }

  async function removeDefi(d) {
    if (!window.confirm('Retirer ce défi ?')) return;
    await deleteDefi(d.id); showToast('Défi retiré'); load();
  }

  async function submitCat(e) {
    e.preventDefault();
    try {
      if (editCat?.id) { await updateCategorieCN(editCat.id, editCat); showToast('Catégorie modifiée'); }
      else { await createCategorieCN(editCat); showToast('Catégorie ajoutée'); }
      setEditCat(null); load();
    } catch(err) { showToast(err.message, 'error'); }
  }

  async function removeCat(cat) {
    if (!window.confirm(`Supprimer la catégorie ${cat.nom} ?`)) return;
    try { await deleteCategorieCN(cat.id); showToast('Catégorie supprimée'); load(); }
    catch(err) { showToast(err.message, 'error'); }
  }

  const defiUtilise = jid => quotas.find(q => q.joueur_id === jid);

  async function faireTirage(tx, jid) {
    try {
      const d = await tirerDefi(jid);
      setTirage({ tx, defi: d.libelle, jid });
    } catch(err) {
      if (err.message === 'Quota atteint') {
        const q = defiUtilise(jid);
        showToast('Défi déjà utilisé ce mois-ci', 'error');
        setTirage({ tx, jid, bloque: true, precedent: q });
      } else showToast(err.message, 'error');
    }
  }

  async function refresh(jid) {
    load();
    if (jid) setTransactions(await getTransactionsJoueur(jid));
  }

  async function supprimerTx(t, jid) {
    if (!window.confirm(`Supprimer définitivement cette amende de ${eur(t.montant)} ?\n\n${t.libelle || t.regle_libelle}`)) return;
    try { await deleteTransaction(t.id); showToast('Amende supprimée'); refresh(jid); }
    catch(err) { showToast(err.message, 'error'); }
  }

  async function faireTransfert(jid) {
    if (!transfert?.dest) return showToast('Choisis un joueur', 'error');
    try {
      await transfererAmende(transfert.tx.id, parseInt(transfert.dest));
      const dest = joueurs.find(j => j.id === parseInt(transfert.dest));
      showToast(`Amende transférée à ${dest?.prenom} ${dest?.nom}`);
      setTransfert(null); refresh(jid);
    } catch(err) { showToast(err.message, 'error'); }
  }

  async function validerDefi(force) {
    try {
      await annulerAmende(tirage.tx.id, tirage.defi, force);
      showToast('Amende effacée — défi réussi');
      setTirage(null); refresh(selJoueur);
    } catch(err) {
      if (err.message.includes('déjà utilisé')) showToast('Quota mensuel atteint', 'error');
      else showToast(err.message, 'error');
    }
  }

  const reglesParCat = cats.map(c => ({ ...c, regles: regles.filter(r => r.categorie_id === c.id) }))
                           .filter(c => c.regles.length);
  const sansCat = regles.filter(r => !r.categorie_id);
  const catDoublable = cats.find(c => c.id === regles.find(r => r.id === parseInt(form.regle_id))?.categorie_id)?.doublable;

  // Formulaire d'un gage : en haut pour un ajout, sous le gage pour une modification
  const formulaireRegle = integre => (
    <div className={integre ? undefined : 'card'} style={integre
      ? { padding:'12px 14px', borderTop:'1px solid var(--border)', background:'rgba(var(--accent-rgb),0.05)' } : { marginBottom:14 }}>
                <div style={{ fontSize:12, fontWeight:700, color:'var(--accent)', letterSpacing:1, textTransform:'uppercase', marginBottom:12 }}>
                  {editRegle ? 'Modifier la règle' : 'Nouvelle règle'}
                </div>
                <form onSubmit={submitRegle}>
                  <div className="form-group"><label>Libellé</label>
                    <input type="text" value={form.libelle||''} onChange={e=>setForm({...form,libelle:e.target.value})} required /></div>
                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                    <div className="form-group" style={{ margin:0 }}><label>Montant (€)</label>
                      <input type="number" step="0.01" min="0" inputMode="decimal" value={form.montant||''}
                        onChange={e=>setForm({...form,montant:parseFloat(e.target.value)})} required /></div>
                    <div className="form-group" style={{ margin:0 }}><label>Catégorie</label>
                      <select value={form.categorie_id||''} onChange={e=>setForm({...form,categorie_id:e.target.value})}>
                        <option value="">— Aucune —</option>
                        {cats.map(c => <option key={c.id} value={c.id}>{c.icone} {c.nom}</option>)}
                      </select></div>
                  </div>
                  <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', margin:'12px 0', fontSize:13 }}>
                    <input type="checkbox" checked={!!form.collective}
                      onChange={e=>setForm({...form,collective:e.target.checked})}
                      style={{ width:16, height:16, accentColor:'var(--accent)' }} />
                    Sanction collective (toute l'équipe par défaut)
                  </label>
                  <div style={{ display:'flex', gap:10 }}>
                    <button type="submit" className="btn btn-primary">{editRegle ? 'Enregistrer' : 'Ajouter'}</button>
                    <button type="button" className="btn btn-secondary"
                      onClick={()=>{setPanel(null);setEditRegle(null);setForm({});}}>Annuler</button>
                  </div>
                </form>
              </div>
  );

  const JoueurPicker = () => {
    const all = cibles.length === joueurs.length && joueurs.length > 0;
    return (
      <div className="form-group">
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 }}>
          <label style={{ margin:0 }}>Joueurs sanctionnés ({cibles.length})</label>
          <button type="button" onClick={()=>setCibles(all ? [] : joueurs.map(j=>j.id))}
            style={{ background:'none', border:'none', color:'var(--accent)', cursor:'pointer',
              fontSize:11, fontWeight:700, textTransform:'uppercase', letterSpacing:1 }}>
            {all ? 'Tout décocher' : "Toute l'équipe"}
          </button>
        </div>
        <div style={{ display:'flex', flexWrap:'wrap', gap:6, maxHeight:170, overflowY:'auto', padding:3 }}>
          {joueurs.map(j => {
            const on = cibles.includes(j.id);
            return (
              <button key={j.id} type="button"
                onClick={()=>setCibles(p => on ? p.filter(x=>x!==j.id) : [...p, j.id])}
                style={{ padding:'7px 11px', borderRadius:8, cursor:'pointer', fontSize:12, fontWeight:600,
                  border:`1px solid ${on ? 'var(--accent)' : 'rgba(255,255,255,0.08)'}`,
                  background: on ? 'rgba(var(--accent-rgb),0.12)' : '#161b22',
                  color: on ? 'var(--accent)' : '#8b949e' }}>
                {on ? '✓ ' : ''}{j.prenom} {j.nom}
              </button>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="page-header">
        <div className="eyebrow">La commission des sanctions</div>
        <h1>💰 Caisse Noire</h1>
        {total && (
          <div className="sub">
            <b style={{ color:'var(--danger)' }}>{eur(total.reste_du)}</b> à encaisser · {eur(total.encaisse)} encaissés
            {total.annulees > 0 && ` · ${eur(total.annulees)} effacés par défi`}
          </div>
        )}
      </div>

      <div className="tabs">
        {[['soldes','💳 Soldes'],['regles','📋 Règles'],['defis','🎲 Défis']].map(([k,l]) => (
          <button key={k} className={`tab-btn ${tab===k?'active':''}`} onClick={()=>{setTab(k);setPanel(null);}}>{l}</button>
        ))}
      </div>

      <div className="section">

        {/* Tirage au sort d'un défi */}
        {tirage && (
          <div className="card" style={{ marginBottom:14,
            borderColor: tirage.bloque ? '#ef4444' : '#eab308',
            background: tirage.bloque ? 'rgba(239,68,68,0.07)' : 'rgba(234,179,8,0.07)' }}>

            {tirage.bloque ? (
              <>
                <div style={{ fontSize:11, fontWeight:700, color:'#ef4444', letterSpacing:2, textTransform:'uppercase', marginBottom:10 }}>
                  ⛔ Quota mensuel atteint
                </div>
                <div style={{ fontSize:13.5, lineHeight:1.6, marginBottom:8 }}>
                  Ce joueur a déjà utilisé son défi ce mois-ci. C'est <b>un défi par joueur et par mois</b>.
                </div>
                {tirage.precedent?.dernier && (
                  <div style={{ background:'#0d1117', borderRadius:8, padding:'10px 13px', fontSize:12, color:'#8b949e' }}>
                    Dernier défi le {tirage.precedent.dernier}
                  </div>
                )}
                <div style={{ display:'flex', gap:8, marginTop:14, flexWrap:'wrap' }}>
                  <button className="btn btn-secondary" onClick={()=>setTirage(null)}>Fermer</button>
                  <button className="btn btn-danger" style={{ width:'auto', padding:'11px 16px' }}
                    onClick={async()=>{
                      if (!window.confirm('Forcer un second défi ce mois-ci pour ce joueur ?')) return;
                      const d = await tirerDefi();
                      setTirage({ ...tirage, defi: d.libelle, bloque: false, force: true });
                    }}>Forcer quand même</button>
                </div>
              </>
            ) : (
              <>
                <div style={{ fontSize:11, fontWeight:700, color:'#eab308', letterSpacing:2, textTransform:'uppercase', marginBottom:10 }}>
                  🎲 Défi tiré au sort
                  {tirage.force && <span style={{ color:'#ef4444', marginLeft:8 }}>· forcé</span>}
                </div>
                <div style={{ fontSize:15, fontWeight:700, lineHeight:1.5, marginBottom:6 }}>{tirage.defi}</div>
                <div style={{ fontSize:12, color:'#8b949e' }}>
                  Amende de {eur(tirage.tx.montant)} — effacée si le défi est réussi.
                </div>
                <div style={{ display:'flex', gap:8, marginTop:14, flexWrap:'wrap' }}>
                  <button className="btn btn-primary" style={{ background:'#22c55e', width:'auto', padding:'11px 16px' }}
                    onClick={()=>validerDefi(tirage.force)}>✓ Défi réussi</button>
                  <button className="btn btn-secondary" style={{ width:'auto', padding:'11px 14px' }}
                    onClick={async()=>{ const d = await tirerDefi(); setTirage({...tirage, defi:d.libelle}); }}>🎲 Retirer</button>
                  <button className="btn btn-secondary" style={{ width:'auto', padding:'11px 14px' }}
                    onClick={()=>setTirage(null)}>Annuler</button>
                </div>
              </>
            )}
          </div>
        )}

        {/* Transfert d'amende */}
        {transfert && (
          <div className="card" style={{ marginBottom:14, borderColor:'#3b82f6', background:'rgba(59,130,246,0.06)' }}>
            <div style={{ fontSize:11, fontWeight:700, color:'#3b82f6', letterSpacing:2, textTransform:'uppercase', marginBottom:10 }}>
              ↔ Transférer l'amende
            </div>
            <div style={{ background:'#0d1117', borderRadius:8, padding:'10px 13px', marginBottom:12, fontSize:13 }}>
              <div style={{ fontWeight:700 }}>{transfert.tx.libelle || transfert.tx.regle_libelle}</div>
              <div style={{ color:'#8b949e', fontSize:11, marginTop:3 }}>
                {eur(transfert.tx.montant)} · {transfert.tx.date}
              </div>
            </div>
            <div className="form-group">
              <label>Nouveau joueur sanctionné</label>
              <select value={transfert.dest} onChange={e=>setTransfert({...transfert, dest:e.target.value})}>
                <option value="">— Choisir —</option>
                {joueurs.filter(j => j.id !== transfert.from).map(j =>
                  <option key={j.id} value={j.id}>{j.prenom} {j.nom}</option>)}
              </select>
            </div>
            <div style={{ display:'flex', gap:8 }}>
              <button className="btn btn-primary" style={{ background:'#3b82f6' }}
                onClick={()=>faireTransfert(transfert.from)}>Transférer</button>
              <button className="btn btn-secondary" onClick={()=>setTransfert(null)}>Annuler</button>
            </div>
          </div>
        )}

        {/* ── SOLDES ── */}
        {tab === 'soldes' && (
          <>
            {isAdmin && !panel && (
              <button className="btn btn-primary" style={{ marginBottom:14 }}
                onClick={()=>openAmende(null)}>+ Amende</button>
            )}

            {panel === 'amende' && (
              <div className="card" style={{ marginBottom:14 }}>
                <div style={{ fontSize:12, fontWeight:700, color:'var(--accent)', letterSpacing:1, textTransform:'uppercase', marginBottom:12 }}>
                  Nouvelle amende
                </div>
                <form onSubmit={submitAmende}>
                  <div className="form-group">
                    <label>Règle</label>
                    <select value={form.regle_id||''} onChange={e=>{
                      const r = regles.find(x => x.id === parseInt(e.target.value));
                      setForm({...form, regle_id:e.target.value, montant:r?.montant ?? '', libelle:r?.libelle || ''});
                      if (r?.collective) setCibles(joueurs.map(j=>j.id));
                    }}>
                      <option value="">— Montant libre —</option>
                      {reglesParCat.map(c => (
                        <optgroup key={c.id} label={`${c.icone} ${c.nom}`}>
                          {c.regles.map(r => (
                            <option key={r.id} value={r.id}>{r.libelle} — {eur(r.montant)}</option>
                          ))}
                        </optgroup>
                      ))}
                      {sansCat.length > 0 && (
                        <optgroup label="Autres">
                          {sansCat.map(r => <option key={r.id} value={r.id}>{r.libelle} — {eur(r.montant)}</option>)}
                        </optgroup>
                      )}
                    </select>
                  </div>

                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                    <div className="form-group" style={{ margin:0 }}><label>Montant (€)</label>
                      <input type="number" step="0.01" min="0.01" inputMode="decimal" value={form.montant??''}
                        onChange={e=>setForm({...form,montant:e.target.value})} required /></div>
                    <div className="form-group" style={{ margin:0 }}><label>Date</label>
                      <input type="date" value={form.date||''} onChange={e=>setForm({...form,date:e.target.value})} /></div>
                  </div>

                  <div className="form-group" style={{ marginTop:10 }}><label>Motif</label>
                    <input type="text" value={form.libelle||''} onChange={e=>setForm({...form,libelle:e.target.value})}
                      placeholder="Ex : Arriver en retard" required /></div>

                  <label style={{ display:'flex', alignItems:'center', gap:9, cursor:'pointer',
                    padding:'11px 13px', borderRadius:8, marginBottom:14,
                    border:`1px solid ${form.jour_match ? '#eab308' : 'rgba(255,255,255,0.08)'}`,
                    background: form.jour_match ? 'rgba(234,179,8,0.1)' : '#161b22' }}>
                    <input type="checkbox" checked={!!form.jour_match}
                      onChange={e=>setForm({...form, jour_match:e.target.checked})}
                      style={{ width:17, height:17, accentColor:'#eab308' }} />
                    <div>
                      <div style={{ fontSize:13, fontWeight:700, color: form.jour_match ? '#eab308' : '#e6edf3' }}>
                        Jour de match — montant doublé
                      </div>
                      {form.montant && (
                        <div style={{ fontSize:11, color:'#8b949e', marginTop:2 }}>
                          {form.jour_match
                            ? `${eur(parseFloat(form.montant))} × 2 = ${eur(parseFloat(form.montant)*2)}`
                            : `Sera prélevé : ${eur(parseFloat(form.montant))}`}
                        </div>
                      )}
                    </div>
                  </label>

                  <JoueurPicker />

                  {cibles.length > 0 && form.montant && (
                    <div style={{ background:'#0d1117', borderRadius:8, padding:'10px 13px', marginBottom:12,
                      fontSize:13, textAlign:'center' }}>
                      Total : <b style={{ color:'var(--danger)', fontSize:16 }}>
                        {eur(parseFloat(form.montant) * (form.jour_match?2:1) * cibles.length)}
                      </b>
                      <span style={{ color:'#8b949e', fontSize:11 }}> ({cibles.length} joueur{cibles.length>1?'s':''})</span>
                    </div>
                  )}

                  <div style={{ display:'flex', gap:10 }}>
                    <button type="submit" className="btn btn-primary">Enregistrer</button>
                    <button type="button" className="btn btn-secondary" onClick={()=>setPanel(null)}>Annuler</button>
                  </div>
                </form>
              </div>
            )}


            <div className="section-title">Soldes — clique pour l'historique</div>
            {soldes.map(s => (
              <div key={s.id}>
                <div className="card card-row" onClick={()=>openJoueur(s.id)}
                  style={{ cursor:'pointer', marginBottom: selJoueur===s.id ? 0 : 8,
                    background: selJoueur===s.id ? 'rgba(var(--accent-rgb),0.06)' : undefined,
                    borderColor: s.id === monJoueurId ? 'rgba(59,130,246,0.45)' : undefined }}>
                  <div>
                    <div style={{ fontSize:14, fontWeight:700 }}>
                      {s.prenom} {s.nom}
                      {s.id === monJoueurId && (
                        <span style={{ fontSize:9.5, color:'#3b82f6', background:'rgba(59,130,246,0.15)',
                          border:'1px solid rgba(59,130,246,0.35)', borderRadius:5,
                          padding:'2px 6px', marginLeft:7, letterSpacing:0.5 }}>MOI</span>
                      )}
                    </div>
                    <div style={{ fontSize:11, color:'#8b949e', marginTop:2 }}>
                      {s.nb_amendes} amende{s.nb_amendes>1?'s':''} · {eur(s.total_paye)} encaissés
                      {defiUtilise(s.id) && <span style={{ color:'#eab308', marginLeft:7 }}>🎲 défi utilisé</span>}
                    </div>
                  </div>
                  <div style={{ textAlign:'right' }}>
                    <div style={{ fontFamily:'Barlow Condensed', fontSize:22, fontWeight:800,
                      color: s.solde > 0.001 ? 'var(--danger)' : '#22c55e' }}>
                      {eur(s.solde)}
                    </div>
                    <div style={{ fontSize:9, color:'#8b949e', letterSpacing:1 }}>
                      {s.nb_impayees > 0 ? `${s.nb_impayees} IMPAYÉE${s.nb_impayees>1?'S':''}` : 'À JOUR'}
                    </div>
                  </div>
                </div>

                {selJoueur === s.id && (
                  <div style={{ background:'rgba(255,255,255,0.02)', border:'1px solid rgba(255,255,255,0.06)',
                    borderTop:'none', borderRadius:'0 0 10px 10px', padding:'10px 14px', marginBottom:8 }}>

                    {isAdmin && s.nb_impayees > 0 && (
                      <div style={{ display:'flex', gap:8, marginBottom:10, flexWrap:'wrap', alignItems:'center' }}>
                        {selPaye.length > 0 ? (
                          <>
                            <button className="btn btn-primary" style={{ background:'#22c55e', width:'auto', padding:'8px 14px', fontSize:12 }}
                              onClick={()=>encaisser(s.id)}>
                              ✓ Encaisser {selPaye.length} · {eur(transactions.filter(t=>selPaye.includes(t.id)).reduce((a,t)=>a+t.montant,0))}
                            </button>
                            <button className="btn btn-secondary" style={{ width:'auto', padding:'8px 12px', fontSize:12 }}
                              onClick={()=>setSelPaye([])}>Désélectionner</button>
                          </>
                        ) : (
                          <>
                            <button className="btn btn-secondary" style={{ width:'auto', padding:'8px 12px', fontSize:12 }}
                              onClick={()=>setSelPaye(transactions.filter(t=>!t.payee && !t.annulee).map(t=>t.id))}>
                              Sélectionner les impayées
                            </button>
                            <button className="btn btn-primary" style={{ background:'#22c55e', width:'auto', padding:'8px 14px', fontSize:12 }}
                              onClick={()=>soldeTout(s)}>✓ Tout solder · {eur(s.solde)}</button>
                          </>
                        )}
                      </div>
                    )}

                    {transactions.length === 0
                      ? <div style={{ color:'#8b949e', fontSize:13, padding:'6px 0' }}>Aucune amende</div>
                      : transactions.map(t => {
                        const sel = selPaye.includes(t.id);
                        return (
                        <div key={t.id} style={{ padding:'9px 0', borderBottom:'1px solid rgba(255,255,255,0.05)',
                          display:'flex', alignItems:'center', gap:9 }}>

                          {isAdmin && !t.annulee && (
                            <input type="checkbox" checked={sel}
                              onChange={()=>setSelPaye(p => sel ? p.filter(x=>x!==t.id) : [...p, t.id])}
                              disabled={t.payee === 1}
                              style={{ width:17, height:17, accentColor:'#22c55e', flexShrink:0,
                                opacity: t.payee ? 0.25 : 1, cursor: t.payee ? 'default' : 'pointer' }} />
                          )}

                          <div style={{ minWidth:0, flex:1 }}>
                            <div style={{ fontSize:12.5,
                              textDecoration: t.annulee ? 'line-through' : 'none',
                              opacity: t.annulee ? 0.5 : t.payee ? 0.6 : 1 }}>
                              {t.categorie_icone && `${t.categorie_icone} `}
                              {t.libelle || t.regle_libelle}
                              {t.jour_match === 1 && <span style={{ color:'#eab308', fontSize:10, marginLeft:5 }}>×2</span>}
                            </div>
                            <div style={{ fontSize:10.5, color:'#8b949e', marginTop:2, display:'flex', gap:7, flexWrap:'wrap' }}>
                              <span>{t.date}</span>
                              {t.payee === 1 && (
                                <span style={{ color:'#22c55e', fontWeight:700 }}>✓ payée{t.paye_le ? ` le ${t.paye_le}` : ''}</span>
                              )}
                              {t.annulee === 1 && <span style={{ color:'#eab308' }}>🎲 {t.defi}</span>}
                            </div>
                          </div>

                          <div style={{ display:'flex', alignItems:'center', gap:6, flexShrink:0 }}>
                            <span style={{ fontWeight:700, fontSize:13, whiteSpace:'nowrap',
                              color: t.annulee ? '#8b949e' : t.payee ? '#22c55e' : 'var(--danger)',
                              textDecoration: t.annulee ? 'line-through' : 'none' }}>
                              {eur(t.montant)}
                            </span>

                            {isAdmin && !t.annulee && (
                              <button onClick={()=>togglePaye(t, s.id)}
                                title={t.payee ? 'Marquer impayée' : 'Marquer payée'}
                                style={{ background: t.payee ? 'rgba(34,197,94,0.15)' : 'none',
                                  border:`1px solid ${t.payee ? 'rgba(34,197,94,0.4)' : 'rgba(255,255,255,0.12)'}`,
                                  borderRadius:6, color: t.payee ? '#22c55e' : '#8b949e',
                                  cursor:'pointer', fontSize:11, padding:'4px 8px', fontWeight:700 }}>
                                {t.payee ? '✓' : '€'}
                              </button>
                            )}

                            {isAdmin && !t.payee && !t.annulee && (
                              <>
                                <button onClick={()=>setTransfert({ tx:t, dest:'', from:s.id })} title="Transférer"
                                  style={{ background:'none', border:'1px solid rgba(59,130,246,0.4)', borderRadius:6,
                                    color:'#3b82f6', cursor:'pointer', fontSize:11, padding:'4px 7px' }}>↔</button>
                                <button onClick={()=>faireTirage(t, s.id)}
                                  title={defiUtilise(s.id) ? 'Défi déjà utilisé ce mois-ci' : 'Tirer un défi'}
                                  style={{ background:'none',
                                    border:`1px solid ${defiUtilise(s.id) ? 'rgba(255,255,255,0.12)' : 'rgba(234,179,8,0.4)'}`,
                                    borderRadius:6, color: defiUtilise(s.id) ? '#4a5568' : '#eab308',
                                    cursor:'pointer', fontSize:11, padding:'4px 7px' }}>🎲</button>
                                <button onClick={()=>supprimerTx(t, s.id)} title="Supprimer"
                                  style={{ background:'none', border:'1px solid rgba(239,68,68,0.35)', borderRadius:6,
                                    color:'#ef4444', cursor:'pointer', fontSize:11, padding:'4px 7px' }}>🗑</button>
                              </>
                            )}

                            {isAdmin && t.annulee === 1 && (
                              <button onClick={async()=>{await reactiverAmende(t.id);refresh(s.id);}} title="Rétablir"
                                style={{ background:'none', border:'1px solid rgba(255,255,255,0.1)', borderRadius:6,
                                  color:'#8b949e', cursor:'pointer', fontSize:11, padding:'4px 7px' }}>↩</button>
                            )}
                          </div>
                        </div>
                        );
                      })}
                  </div>
                )}
              </div>
            ))}
          </>
        )}

        {/* ── RÈGLES ── */}
        {tab === 'regles' && (
          <>
            {isAdmin && !panel && (
              <div style={{ display:'flex', gap:8, marginBottom:14 }}>
                <button className="btn btn-primary" style={{ flex:1 }}
                  onClick={()=>{setEditRegle(null);setForm({});setPanel('regle');}}>+ Règle</button>
                <button className="btn btn-secondary" style={{ flex:1 }}
                  onClick={()=>setShowCats(!showCats)}>🏷️ Catégories</button>
              </div>
            )}

            {/* Gestion des catégories */}
            {isAdmin && showCats && (
              <div className="card" style={{ marginBottom:14 }}>
                <div style={{ fontSize:12, fontWeight:700, color:'#3b82f6', letterSpacing:1, textTransform:'uppercase', marginBottom:12 }}>
                  Catégories
                </div>
                {cats.map(cat => (
                  <div key={cat.id} style={{ display:'flex', justifyContent:'space-between', alignItems:'center',
                    gap:8, padding:'9px 0', borderBottom:'1px solid rgba(255,255,255,0.05)' }}>
                    <div style={{ fontSize:13 }}>
                      {cat.icone} {cat.nom}
                      {cat.doublable === 1 && <span style={{ color:'#eab308', fontSize:10, marginLeft:6 }}>×2 match</span>}
                    </div>
                    <div style={{ display:'flex', gap:6 }}>
                      <button onClick={()=>setEditCat({ ...cat })}
                        style={{ background:'none', border:'1px solid rgba(255,255,255,0.1)', borderRadius:6,
                          color:'#8b949e', cursor:'pointer', fontSize:11, padding:'4px 8px' }}>✏️</button>
                      <button onClick={()=>removeCat(cat)}
                        style={{ background:'none', border:'none', color:'#8b949e', cursor:'pointer', fontSize:13 }}>🗑️</button>
                    </div>
                  </div>
                ))}
                <button className="btn btn-secondary" style={{ marginTop:12 }}
                  onClick={()=>setEditCat({ nom:'', icone:'📌', doublable:0 })}>+ Nouvelle catégorie</button>
              </div>
            )}

            {/* Formulaire catégorie */}
            {isAdmin && editCat && (
              <div className="card" style={{ marginBottom:14, borderColor:'#3b82f6' }}>
                <div style={{ fontSize:12, fontWeight:700, color:'#3b82f6', letterSpacing:1, textTransform:'uppercase', marginBottom:12 }}>
                  {editCat.id ? 'Modifier la catégorie' : 'Nouvelle catégorie'}
                </div>
                <form onSubmit={submitCat}>
                  <div style={{ display:'grid', gridTemplateColumns:'70px 1fr', gap:10 }}>
                    <div className="form-group" style={{ margin:0 }}><label>Icône</label>
                      <input type="text" value={editCat.icone||''} maxLength={2}
                        onChange={e=>setEditCat({...editCat, icone:e.target.value})}
                        style={{ textAlign:'center', fontSize:18 }} /></div>
                    <div className="form-group" style={{ margin:0 }}><label>Nom</label>
                      <input type="text" value={editCat.nom||''}
                        onChange={e=>setEditCat({...editCat, nom:e.target.value})} required /></div>
                  </div>
                  <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', margin:'12px 0', fontSize:13 }}>
                    <input type="checkbox" checked={!!editCat.doublable}
                      onChange={e=>setEditCat({...editCat, doublable:e.target.checked?1:0})}
                      style={{ width:16, height:16, accentColor:'#eab308' }} />
                    Montants doublables les jours de match
                  </label>
                  <div style={{ display:'flex', gap:10 }}>
                    <button type="submit" className="btn btn-primary">Enregistrer</button>
                    <button type="button" className="btn btn-secondary" onClick={()=>setEditCat(null)}>Annuler</button>
                  </div>
                </form>
              </div>
            )}

            {panel === 'regle' && !editRegle && formulaireRegle(false)}

            {reglesParCat.map(c => (
              <div key={c.id} style={{ marginBottom:10 }}>
                <button onClick={()=>setOpenCat(openCat===c.id?null:c.id)}
                  style={{ width:'100%', background:'#161b22', border:'1px solid rgba(255,255,255,0.08)',
                    borderRadius: openCat===c.id ? '10px 10px 0 0' : 10, padding:'12px 14px', cursor:'pointer',
                    display:'flex', justifyContent:'space-between', alignItems:'center', color:'#e6edf3' }}>
                  <div style={{ textAlign:'left' }}>
                    <div style={{ fontSize:13.5, fontWeight:700 }}>{c.icone} {c.nom}</div>
                    <div style={{ fontSize:10.5, color:'#8b949e', marginTop:2 }}>
                      {c.regles.length} règle{c.regles.length>1?'s':''}
                      {c.doublable === 1 && <span style={{ color:'#eab308' }}> · ×2 jour de match</span>}
                    </div>
                  </div>
                  <span style={{ color:'var(--accent)', fontSize:13 }}>{openCat===c.id ? '▾' : '▸'}</span>
                </button>

                {openCat === c.id && (
                  <div style={{ border:'1px solid rgba(255,255,255,0.08)', borderTop:'none',
                    borderRadius:'0 0 10px 10px', overflow:'hidden' }}>
                    {c.regles.map((r, i) => (<div key={r.id} id={`regle-${r.id}`}>
                      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center',
                        gap:10, padding:'11px 14px', background: i%2 ? 'rgba(255,255,255,0.015)' : 'transparent',
                        borderTop:'1px solid rgba(255,255,255,0.04)' }}>
                        <div style={{ fontSize:12.5, lineHeight:1.4, flex:1, minWidth:0 }}>
                          {r.libelle}
                          {r.collective === 1 && <span style={{ fontSize:9.5, color:'#3b82f6', marginLeft:6 }}>ÉQUIPE</span>}
                        </div>
                        <div style={{ display:'flex', alignItems:'center', gap:7, flexShrink:0 }}>
                          <span style={{ fontFamily:'Barlow Condensed', fontSize:16, fontWeight:800, color:'var(--danger)' }}>
                            {eur(r.montant)}
                          </span>
                          {isAdmin && (
                            <>
                              <button onClick={()=>openAmende(r)} title="Sanctionner"
                                style={{ background:'rgba(var(--danger-rgb),0.12)', border:'1px solid rgba(var(--danger-rgb),0.35)',
                                  borderRadius:6, color:'var(--danger)', cursor:'pointer', fontSize:11,
                                  fontWeight:700, padding:'5px 9px', whiteSpace:'nowrap' }}>+ Sanction</button>
                              <button onClick={()=>openEditRegle(r)} title="Modifier" aria-expanded={panel === 'regle' && editRegle?.id === r.id}
                                style={{ background:'none', border:'1px solid rgba(255,255,255,0.1)', borderRadius:6,
                                  color:'#8b949e', cursor:'pointer', fontSize:11, padding:'5px 8px' }}>✏️</button>
                              <button onClick={async()=>{if(window.confirm('Retirer cette règle ?')){await deleteRegle(r.id);load();}}}
                                style={{ background:'none', border:'none', color:'#8b949e', cursor:'pointer', fontSize:13 }}>🗑️</button>
                            </>
                          )}
                        </div>
                      </div>
                      {panel === 'regle' && editRegle?.id === r.id && formulaireRegle(true)}
                    </div>))}
                  </div>
                )}
              </div>
            ))}

            {sansCat.length > 0 && (
              <>
                <div className="section-title" style={{ marginTop:16 }}>Autres règles</div>
                {sansCat.map(r => (
                  <div className="card card-row" key={r.id} style={{ padding:'11px 14px' }}>
                    <div style={{ fontSize:13 }}>{r.libelle}</div>
                    <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                      <span style={{ fontWeight:800, color:'var(--danger)' }}>{eur(r.montant)}</span>
                      {isAdmin && <button onClick={()=>openAmende(r)}
                        style={{ background:'rgba(var(--danger-rgb),0.12)', border:'1px solid rgba(var(--danger-rgb),0.35)',
                          borderRadius:6, color:'var(--danger)', cursor:'pointer', fontSize:11, fontWeight:700, padding:'5px 9px' }}>+</button>}
                    </div>
                  </div>
                ))}
              </>
            )}
          </>
        )}

        {/* ── DÉFIS ── */}
        {tab === 'defis' && (
          <>
            <div className="card" style={{ marginBottom:14, background:'rgba(234,179,8,0.05)', borderColor:'rgba(234,179,8,0.25)' }}>
              <div style={{ fontSize:12.5, lineHeight:1.6, color:'#e6edf3' }}>
                En cas de vote conclu par une égalité, le joueur peut tenter un défi tiré au sort pour effacer sa sanction.
              </div>
              <div style={{ fontSize:11, color:'#8b949e', marginTop:8 }}>
                Le tirage se lance depuis l'historique d'un joueur, avec le bouton 🎲 à côté de l'amende.
              </div>
              <div style={{ fontSize:12, fontWeight:700, color:'#eab308', marginTop:10,
                paddingTop:10, borderTop:'1px solid rgba(234,179,8,0.2)' }}>
                ⚠️ Un seul défi par joueur et par mois
              </div>
            </div>

            {isAdmin && !editDefi && (
              <form onSubmit={submitDefi} style={{ marginBottom:16 }}>
                <div className="form-group" style={{ marginBottom:0 }}>
                  <label>{editDefi ? 'Modifier le défi' : 'Nouveau défi'}</label>
                  <div style={{ display:'flex', gap:8 }}>
                    <input type="text" value={newDefi} onChange={e=>setNewDefi(e.target.value)}
                      placeholder="Ex : Faire 20 pompes devant l'équipe" required />
                    <button type="submit" className="btn btn-primary"
                      style={{ width:'auto', padding:'0 16px', whiteSpace:'nowrap' }}>
                      {editDefi ? 'OK' : 'Ajouter'}
                    </button>
                    {editDefi && (
                      <button type="button" className="btn btn-secondary"
                        style={{ width:'auto', padding:'0 14px' }}
                        onClick={()=>{setEditDefi(null);setNewDefi('');}}>✕</button>
                    )}
                  </div>
                </div>
              </form>
            )}

            {quotas.length > 0 && (
              <>
                <div className="section-title">Défis utilisés ce mois-ci</div>
                <div className="card" style={{ marginBottom:16, padding:'12px 14px' }}>
                  {quotas.map(q => {
                    const j = joueurs.find(x => x.id === q.joueur_id);
                    return (
                      <div key={q.joueur_id} style={{ display:'flex', justifyContent:'space-between',
                        fontSize:12.5, padding:'5px 0' }}>
                        <span>{j ? `${j.prenom} ${j.nom}` : 'Joueur retiré'}</span>
                        <span style={{ color:'#8b949e', fontSize:11 }}>{q.dernier}</span>
                      </div>
                    );
                  })}
                </div>
              </>
            )}

            <div className="section-title">
              {defis.length} défi{defis.length>1?'s':''} possible{defis.length>1?'s':''}
            </div>
            {defis.map((d, i) => (
              <div className="card" key={d.id} id={`defi-${d.id}`} style={{ padding:'12px 14px', borderColor: editDefi?.id === d.id ? 'var(--accent)' : undefined }}>
                <div style={{ display:'flex', gap:11, alignItems:'center' }}>
                <span style={{ width:24, height:24, borderRadius:6, background:'rgba(234,179,8,0.15)',
                  color:'#eab308', display:'flex', alignItems:'center', justifyContent:'center',
                  fontSize:11, fontWeight:800, flexShrink:0 }}>{i+1}</span>
                <div style={{ fontSize:13, lineHeight:1.5, flex:1 }}>{d.libelle}</div>
                {isAdmin && (
                  <div style={{ display:'flex', gap:6, flexShrink:0 }}>
                    <button aria-expanded={editDefi?.id === d.id} onClick={()=>{ if (editDefi?.id === d.id) { setEditDefi(null); setNewDefi(''); return; }
                      setEditDefi(d); setNewDefi(d.libelle); setTimeout(() => document.getElementById(`defi-${d.id}`)?.scrollIntoView({ behavior:'smooth', block:'nearest' }), 60); }}
                      style={{ background:'none', border:'1px solid rgba(255,255,255,0.1)', borderRadius:6,
                        color:'#8b949e', cursor:'pointer', fontSize:11, padding:'5px 8px' }}>✏️</button>
                    <button onClick={()=>removeDefi(d)}
                      style={{ background:'none', border:'none', color:'#8b949e', cursor:'pointer', fontSize:13 }}>🗑️</button>
                  </div>
                )}
                </div>
                {isAdmin && editDefi?.id === d.id && (
                  <form onSubmit={submitDefi} style={{ marginTop:12, paddingTop:12, borderTop:'1px solid var(--border)', display:'flex', gap:8 }}>
                    <input type="text" value={newDefi} onChange={e=>setNewDefi(e.target.value)} required autoFocus aria-label="Modifier le défi" />
                    <button type="submit" className="btn btn-primary" style={{ width:'auto', padding:'0 16px' }}>OK</button>
                    <button type="button" className="btn btn-secondary" style={{ width:'auto', padding:'0 14px' }}
                      onClick={()=>{setEditDefi(null);setNewDefi('');}}>✕</button>
                  </form>
                )}
              </div>
            ))}
            {defis.length === 0 && (
              <div className="card" style={{ textAlign:'center', color:'#8b949e', padding:'24px 16px' }}>
                Aucun défi enregistré.
              </div>
            )}
          </>
        )}

      </div>
      {toast && <div className={`toast ${toast.type}`}>{toast.msg}</div>}
    </>
  );
}
